import * as actionTypes from './actionTypes';
import axios from '../../utilities/interceptor';
import { getMessage } from '../../utilities/getMessage';

export const completeWithdraw=(id)=>async dispatch=>{
    dispatch({
        type:actionTypes.COMPLETE_WITHDRAW_START
    });
    const options={
        url:`/withdrawals/${id}/complete`,
        method:'POST'
    }
    await axios(options)
                .then(response=>dispatch({
                    type:actionTypes.COMPLETE_WITHDRAW_SUCCESS,
                    payload:response.data
                }))
                .catch(error=>dispatch({
                    type:actionTypes.COMPLETE_WITHDRAW_FAIL,
                    payload:getMessage(error)
                }))
    
}